import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  DataGridView,
  Button,
  Row,
  Col,
} from "@neumetric/blueprint-lib/components";
import { auditActions, getReportList } from "../../store";

export const ReportTrackerScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reportList = useSelector(getReportList);

  React.useEffect(() => {
    fetchReportList(1);
  }, []);

  const fetchReportList = (pageNo) => {
    dispatch(auditActions.fetchReportList({ page: pageNo, per_page: 10 }));
  };

  const handleShowReportDetails = (record) => {
    navigate(`/A/R/${record.id}`);
  };

  const handlePageChange = (pageNo) => {
    fetchReportList(pageNo);
  };

  return (
    <Col className="w-100 h-100 pos-relative overflow-hide">
      <Row className="w-100 mb-20 pr-10" justify="end">
        <Button
          icon="UPLOAD"
          label="Upload Report"
          onClick={() => navigate("/A/R/new")}
        />
      </Row>
      <Row className="w-100 h-100 mb-10 pl-10 pr-10 pt-10">
        <DataGridView
          columns={ReportColumns}
          dataSource={reportList?.rows || []}
          rowKey="key"
          EmptyComponent={<div>There are no records available.</div>}
          getCellSemantics={(column, record) => {
            const semantics = {};
            if (column.dataIndex === "report_id") {
              semantics.onLinkClick = () => handleShowReportDetails(record);
            }
            return semantics;
          }}
          pagination={
            reportList && reportList.meta
              ? {
                  totalCount: reportList.meta.total_entries,
                  pageSize: reportList.meta.per_page,
                  defaultPage: 1,
                  onPageChange: handlePageChange,
                }
              : null
          }
        />
      </Row>
    </Col>
  );
};

export const ReportColumns = [
  {
    title: "Report ID",
    dataIndex: "report_id",
    typeRepresentation: "LINK",
    width: "10%",
  },
  {
    title: "Report Date",
    dataIndex: "report_date",
    typeRepresentation: "TEXT",
    width: "10%",
    sortableFlag: true,
  },
  {
    title: "Title",
    dataIndex: "title",
    typeRepresentation: "TEXT",
    width: "20%",
  },
  {
    title: "Assessor",
    dataIndex: "governor",
    typeRepresentation: "TEXT",
    width: "20%",
  },
  {
    title: "Responder",
    dataIndex: "user",
    typeRepresentation: "TEXT",
    width: "20%",
  },
  {
    title: "Framework",
    dataIndex: "framework",
    typeRepresentation: "TEXT",
    width: "20%",
  },
];
